<template lang="html">

  <div class="candidaturas-view container">

    <h2 v-if="esHome">{{ $t('orientacion.titulo') }}</h2>
    <h2 v-else>{{ $t('orientacion.titulo_categoria_recursos') }}</h2>

    <h3 v-if="esHome">{{ $t('orientacion.pie') }}</h3>
    <div class="row cont-orientacion-info">
      <div class="col-lg-2coma4 col-sm-6 card-orientacion-info withborder"
        v-for="tipoRecurso in dominios.tipoCategoriaRecursos">
        <router-link :to="$t('enlaces.recursos') + '/' + tipoRecurso.idTipoCategoriaRecurso"></router-link>
        <div style="width:100%;">
          <img :src="'data:application/gzip;base64,' + tipoRecurso.imagen">
        </div>
        <label>{{ tipoRecurso.descripcion }}</label>
      </div>
    </div>
    <!--     
    <div class="row cont-orientacion-info" >
      <div class="col-lg-2coma4 col-sm-6 card-orientacion-info withborder">
        <img src="/static/img/icons/orientacion-mi-cv.svg">
        <label>{{$t('orientacion.mi_cv')}}</label>
      </div>
      <div class="col-lg-2coma4 col-sm-6 card-orientacion-info withborder">
        <img src="/static/img/icons/orientacion-entrevista.svg">
        <label>{{$t('orientacion.entrevista')}}</label>
      </div>
      <div class="col-lg-2coma4 col-sm-6 card-orientacion-info withborder">
        <img src="/static/img/icons/orientacion-mi-carrera.svg">
        <label>{{$t('orientacion.mi_carrera')}}</label>
      </div>
      <div class="col-lg-2coma4 col-sm-6 card-orientacion-info withborder">
        <img src="/static/img/icons/orientacion-oportunidades.svg">
        <label>{{$t('orientacion.oportunidades_profesionales')}}</label>
      </div>
      <div class="col-lg-2coma4 col-sm-6 card-orientacion-info">
        <img src="/static/img/icons/orientacion-busqueda-profesional.svg">
        <label>{{$t('orientacion.busqueda_internacional')}}</label>
      </div>
    </div> -->

  </div>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'modulo-orientacion-info',
  props: ['esHome'],
  components: {
  },
  mounted() {

  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    ]),
  },
  computed: {
    ...mapGetters({
      colors: 'basicColors',
      style: 'getStyles',
      dominios: 'getDominios'
    }),
  },
}
</script>

<style scoped lang="scss">
.candidaturas-view {
  width: 100%
}

h2 {
  font-weight: 800;
  width: 100%;
  font-size: 36px;
  margin-top: 100px;
  color: #386DB0;
}

h3 {
  margin: 30px 0;
}

.withborder {
  border-left: 1px solid #386DB0;
  border-right: 1px solid #386DB0;

  &:first-of-type,
  &:last-of-type {
    border: 0;
  }
}

.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.col-lg-2coma4,
.col-sm-6 {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

@media (min-width: 576px) {
  .col-sm-6 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (min-width: 992px) {
  .col-lg-2coma4 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 16.66666%;
    flex: 0 0 16.66666%;
    max-width: 16.66666%;
  }
}

@media screen and (max-width: 992px) {
  .withborder {
    border-left: 0px solid #386DB0;
    border-right: 0px solid #386DB0;
  }
}









@media screen and (max-width: 380px) {
  .selector-tipo a {
    padding-right: 3px;
    margin-right: 3px;
    font-size: 12px;
  }

}


@media screen and (max-width: 330px) {
  .selector-tipo a {
    padding-right: 4px;
    margin-right: 4px;
    font-size: 10px;
  }
}

@media screen and (max-width: 500px) {
  .status {
    margin: 0 10px;
  }
}


.card-orientacion-info>div>img {
  // width: 100%;
  // height: 60px;
  margin: 10px 0px;
  width: auto;
  height: auto;
  max-height: 60px;
  max-height: 60px;

}

.card-orientacion-info>label {
  font-weight: 600;
  width: 100%;
  font-size: 16px;
  margin-top: 100px;
  color: #4A4A4A;
}


.card-orientacion-info>a {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-orientacion-info.vue